<div class="page-layout-container">
  <div class="row">
    <h1 class="title">All Contracts</h1>
  </div>

  <div>
    <mat-form-field appearance="standard">
      <mat-label>Filter</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="search with Contract id, name,.."
        #input
      />
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="employeeId">
        <th mat-header-cell *matHeaderCellDef>Employee Id</th>
        <td mat-cell *matCellDef="let element">{{ element.employeeId }}</td>
      </ng-container>

      <ng-container matColumnDef="customerId">
        <th mat-header-cell *matHeaderCellDef>Customer Id</th>
        <td mat-cell *matCellDef="let element">{{ element.customerId }}</td>
      </ng-container>

      <ng-container matColumnDef="contractType">
        <th mat-header-cell *matHeaderCellDef>Contract Type</th>
        <td mat-cell *matCellDef="let element">{{ element.contractType }}</td>
      </ng-container>

      <ng-container matColumnDef="nishContractId">
        <th mat-header-cell *matHeaderCellDef>NISH Contract Id</th>
        <td mat-cell *matCellDef="let element">{{ element.nishContractId }}</td>
      </ng-container>

      <ng-container matColumnDef="contractStatus">
        <th mat-header-cell *matHeaderCellDef>Contract Status</th>
        <td mat-cell *matCellDef="let element">{{ element.contractStatus }}</td>
      </ng-container>

      <ng-container matColumnDef="clientName">
        <th mat-header-cell *matHeaderCellDef>Client Name</th>
        <td mat-cell *matCellDef="let element">{{ element.clientName }}</td>
      </ng-container>

      <ng-container matColumnDef="billingRate">
        <th mat-header-cell *matHeaderCellDef>Billing Rate</th>
        <td mat-cell *matCellDef="let element">{{ element.billingRate }}</td>
      </ng-container>

      <ng-container matColumnDef="contractStartDate">
        <th mat-header-cell *matHeaderCellDef>Contract StartDate</th>
        <td mat-cell *matCellDef="let element">
          {{ element.contractStartDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contractEndDate">
        <th mat-header-cell *matHeaderCellDef>Contract EndDate</th>
        <td mat-cell *matCellDef="let element">
          {{ element.contractEndDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contractReference">
        <th mat-header-cell *matHeaderCellDef>Contract Reference</th>
        <td mat-cell *matCellDef="let element">
          {{ element.contractReference }}
        </td>
      </ng-container>

      <ng-container matColumnDef="vosReference">
        <th mat-header-cell *matHeaderCellDef>VOS Reference</th>
        <td mat-cell *matCellDef="let element">{{ element.vosReference }}</td>
      </ng-container>

      <ng-container matColumnDef="entity">
        <th mat-header-cell *matHeaderCellDef>Entity</th>
        <td mat-cell *matCellDef="let element">{{ element.entity }}</td>
      </ng-container>

      <ng-container matColumnDef="tsFlag">
        <th mat-header-cell *matHeaderCellDef>TimeSheet Flag</th>
        <td mat-cell *matCellDef="let element">{{ element.tsFlag }}</td>
      </ng-container>
      <ng-container matColumnDef="invoicesDH">
        <th mat-header-cell *matHeaderCellDef>Invoices Days/Hrs</th>
        <td mat-cell *matCellDef="let element">{{ element.invoicesDH }}</td>
      </ng-container>
      <ng-container matColumnDef="comments">
        <th mat-header-cell *matHeaderCellDef>Comments</th>
        <td mat-cell *matCellDef="let element">{{ element.comments }}</td>
      </ng-container>

      <ng-container matColumnDef="contractUpdatedDate">
        <th mat-header-cell *matHeaderCellDef>Contract Created/Updated Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.updatedDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contractUpdatedBy">
        <th mat-header-cell *matHeaderCellDef>Contract Created/Updated User</th>
        <td mat-cell *matCellDef="let element">{{ element.updatedBy }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
  <app-progress [loading$]="loading$"> </app-progress>
</div>
